
export default function Main(props) {
    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 mt-4">
            {props.children}
        </main>
    )
}